import { Lottie, LottieOptions } from '@rhg/libs/lottie-react';
import darkLoadingDots from '@rhg/libs/lottie-react/animations/loading-dots-dark';
import lightLoadingDots from '@rhg/libs/lottie-react/animations/loading-dots-light';
import { Box, SxProps, Theme, useTheme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { useMemo } from 'react';

const styleWrapper = { width: 94, height: 24 };

export function LoadingDots({ sx }: { sx?: SxProps<Theme> }) {
    const {
        palette: { mode },
    } = useTheme();

    const options = useMemo<LottieOptions>(
        () => ({
            animationData: mode === 'dark' ? darkLoadingDots : lightLoadingDots,
            autoplay: true,
            loop: false,
        }),
        [mode]
    );

    return (
        <Box sx={sxAppend(styleWrapper, sx)} data-testid="LoadingDots">
            <Lottie {...options} />
        </Box>
    );
}
